import React from "react";
import ContactPage from "./ContactPage";
import { motion } from "framer-motion";

const Phpdev = () => {
  return (
    <>
      <section className="d-flex flex-column">
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: "easeOut" }}
        >
          <div className="hiremain m mb2 d-flex flex-column justify-content-start justify-content-md-center align-items-start align-items-md-center text-md-center text-start">
            <h2 className="wefocush4 fsh2 m0 mb2" style={{ color: "#137eb1" }}>
              Hire Our Professional PHP{" "}
              <span style={{ color: "black" }}> Developers</span>
            </h2>
            <p className="hiremainp fsp m0 mb2 col-10">
              Hire Our Professional Website Developers to bring your vision to
              life. With expertise in custom designs, responsive development and
              seamless functionality, we ensure your website delivers
              exceptional user experiences and business growth.
            </p>
          </div>
        </motion.div>
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: "easeOut" }}
        >
        <div className="hire m0 mb2 ">
          <div className="hire1">
            <img src="/images/image 45.webp" alt="" className="hireimg" />
            <p className="fsh4">Monthly</p>
          </div>
          <div className="hire1">
            <img src="/images/image 46.webp" alt="" className="hireimg" />
            <p className="fsh4">Hourly</p>
          </div>
                  
          <div className="hire1">
            <img src="/images/image 47.webp" alt="" className="hireimg" />
            <p className="fsh4">Maintenance</p>
          </div>
          <div className="hire1">
            <img src="/images/image 48.webp" alt="" className="hireimg" />
            <p className="fsh4">Contract</p>
          </div>

        </div>
        </motion.div>
        <div className="design p m1">
          <div style={{ color: "white" }}>
            <h3 className="fsh4 m0 mb2">
              Looking for{" "}
              <span style={{ color: "#FAAB1E" }}>Top-Tier PHP Developers?</span>
               
            </h3>

            <p style={{ color: "white" }} className="desh2 fsp m0 mb3">
              Hire Our Team of Expert Developers and Elevate Your Online
              Presence!
            </p>
          </div>
          <div>
            <button className="hiremebtn">
              <a
                style={{ textDecoration: "none", color: "white" }}
                href="/contact"
              >
                Hire Now!
              </a>
            </button>
          </div>
        </div>
      </section>
      <ContactPage />
    </>
  );
};

export default Phpdev;
